import React from 'react';
import DayPeriodSelectComponent from '../../components/Filters/dayPeriodSelect';
class DatePeriodSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dayPeriod: '',
        }
        this.handleChangePeriod = this.handleChangePeriod.bind(this);
    }

    componentDidMount(){
        this.setState({dayPeriod:''});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filters !== this.props.filters) {
            this.setState({dayPeriod:''});
        }
    }

    /**
     * Asigna periodo del día seleccionado y actualiza mensaje de filtros con dato seleccionado.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un periodo del día.
    */
    handleChangePeriod(e) {
        const { id, name, updateFiltersMessage, data } = this.props;
        const dayPeriod=e.target.value;
        var parametersArray = [];
        var parameters = '';
        this.setState({ dayPeriod:dayPeriod});
        var dayPeriodId;
        data.map(dataItem => {
            if (dataItem.name === dayPeriod) 
            dayPeriodId = dataItem.id
        });
        parametersArray.push(
            '<parameter>',
            '<id>',
            dayPeriodId,
            '</id>',
            '<name>',
            dayPeriod,
            '</name>',
            '</parameter>'
        )
        parameters = parametersArray.join('');
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }
        updateFiltersMessage(message);
    };

    render() {
        const { dayPeriod } = this.state;
        const { data, required } = this.props;
        return (
            <DayPeriodSelectComponent
                dayPeriod={dayPeriod}
                data={data}
                required={required}
                handleChangePeriod={this.handleChangePeriod}
            />
        )
    }
}

export default DatePeriodSelect;